/**
 * Hebrew / Israel Flag Icon
 */
import React from 'react';

interface FlagHeIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const FlagHeIcon: React.FC<FlagHeIconProps> = ({
  width = 24,
  height = 18,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`flag-icon flag-icon--he ${className}`}
    >
      <rect width="24" height="18" rx="2" fill="white" />
      {/* Top blue stripe */}
      <rect y="3" width="24" height="3" fill="#0038B8" />
      {/* Bottom blue stripe */}
      <rect y="12" width="24" height="3" fill="#0038B8" />
      {/* Star of David (simplified) */}
      <polygon
        points="12,6.5 13.3,8.75 15.8,8.75 14.15,10.5 14.9,12.75 12,11.4 9.1,12.75 9.85,10.5 8.2,8.75 10.7,8.75"
        fill="#0038B8"
      />
    </svg>
  );
};

export default FlagHeIcon;
